<template>
    <div class="flex items-center justify-between p-5 bg-surface-raised rounded-xl border-2 border-border gap-4">
        <div class="flex items-center gap-4 min-w-0">
            <div class="w-10 h-10 flex-shrink-0 rounded-xl overflow-hidden flex items-center justify-center">
                <slot name="icon" />
            </div>
            <div class="min-w-0">
                <div class="flex items-center gap-2">
                    <div class="body-bold text-ink">{{ name }}</div>
                    <BaseChip v-if="badge" size="xs" class="text-ink-muted">{{ badge }}</BaseChip>
                </div>
                <div class="body-small text-ink-muted">{{ description }}</div>
            </div>
        </div>
        <div class="flex items-center gap-3 flex-shrink-0">
            <div v-if="connected" class="hidden sm:flex items-center gap-2 body-small text-notification-success-text">
                <div class="w-2 h-2 rounded-full bg-current"></div>
                {{ t("components.integrationCard.connected") }}
            </div>
            <div v-else-if="showStatus && !comingSoon" class="hidden sm:flex items-center gap-2 body-small text-ink-muted">
                <div class="w-2 h-2 rounded-full bg-current"></div>
                {{ t("components.integrationCard.notConnected") }}
            </div>
            <BaseButton v-if="comingSoon" theme="neutral" size="sm" disabled> {{ t("components.integrationCard.comingSoon") }} </BaseButton>
            <template v-else-if="!connected && actionHref">
                <BaseLink
                    :href="actionHref"
                    class="base-btn-neutral base-btn-sm"
                    :aria-label="t('components.integrationCard.actionWithName', { action: resolvedActionLabel, name })"
                    >{{ resolvedActionLabel }}</BaseLink
                >
            </template>
            <template v-else-if="!connected">
                <BaseButton theme="neutral" size="sm" @click="$emit('connect')">{{ resolvedActionLabel }}</BaseButton>
            </template>
            <template v-else>
                <BaseButton theme="tertiary" size="sm" @click="$emit('settings')">{{ t("components.integrationCard.settings") }}</BaseButton>
            </template>
        </div>
    </div>
</template>

<script setup lang="ts">
import BaseButton from "~vue/components/BaseButton.vue";
import BaseChip from "~vue/components/BaseChip.vue";
import BaseLink from "~vue/router/BaseLink.vue";
import { computed } from "vue";
import { useI18n } from "vue-i18n";

const { t } = useI18n();

const {
    actionHref = "",
    actionLabel,
    showStatus = true,
} = defineProps<{
    name: string;
    description: string;
    connected?: boolean;
    comingSoon?: boolean;
    badge?: string;
    actionHref?: string;
    actionLabel?: string;
    showStatus?: boolean;
}>();

const resolvedActionLabel = computed(() => actionLabel ?? t("components.integrationCard.connect"));

defineEmits<{
    connect: [];
    settings: [];
}>();
</script>
